import Label from "components/general/Label";
import { useQueryClient } from "react-query";
import { useState, useEffect } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode, { getSportCodeObject } from "components/common/SportCode";
import { getRscObject } from "helpers/rsc";
import { RscFromStore } from "helpers/utils";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
const asterisc = <FontAwesomeIcon className="font-icon" icon={faAsterisk} />;


export function ColumnApparatus({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderApparatus',
    remove = false
}) {
    const [dataSportCodes, setDataSportCodes] = useState()
    const queryClient = useQueryClient();
    const { mirs_discipline, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    useEffect(() => {
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])

    return (
        {
            Header: <Label data={label} />,
            accessor: props => {
                const apparatus = props?.eventUnitEntries?.find(eue => eue?.eue_code === 'APPARATUS')?.eue_value;              
                const apparatusDescription = apparatus ? getSportCodeObject(dataSportCodes, mirs_discipline, '@Apparatus', apparatus)?.description : '';
                return apparatusDescription;
            },
            id: 'Apparatus',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                const apparatus = row?.eventUnitEntries?.find(eue => eue?.eue_code === 'APPARATUS')?.eue_value;              
                const apparatusDescription = apparatus ? getSportCodeObject(dataSportCodes, mirs_discipline, '@Apparatus', apparatus)?.description : '';
                return apparatus ? apparatusDescription : ''
            }
        }
    )
}

// 'HOOP' 'BALL', 'CLUBS', 'RIBBON', '3_RIBBONS_2_BALLS', '5_HOOPS'
export function ColumnResultApparatus({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderApparatus',
    remove = false,
    apparatus = ''

}) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    return (
        {
            Header: <SportCode discipline={mirs_discipline} entity='@APPARATUS' code={apparatus} />,
            accessor: props => {
                    const erSortOrder = props?.extendedResults?.find(er => er?.er_code === apparatus)?.er_sortorder;
                    return erSortOrder ? erSortOrder : props?.sortOrder;
                },
            id: apparatus,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                const result = row?.extendedResults?.find(er => er?.er_code === apparatus);
                const irmOrResult = result?.er_irm ? <SportCode discipline={mirs_discipline} entity='@IRM' code={result?.er_irm} abbr={true} /> : result?.er_value ? <>{result?.er_value}</> : <></>                
                return  <>{irmOrResult} {result?.er_rank ? `(${result?.er_rank})` : ''}</>
            }
        }
    )
}

export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,

            Cell: (props) => {
                const res = props.cell.row.original;              
                
                let irmOrResult = res?.resultIrm ? <SportCode discipline={getRscObject(RscFromStore()).discipline} entity='@IRM' code={res?.resultIrm} abbr={true} /> : res?.resultData ? <>{res?.resultData}</> : <></>;
                
                const score = res?.extendedResults?.find(r => '|3_RIBBONS_2_BALLS|5_HOOPS|BALL|CLUBS|HOOP|RIBBON|'.includes(r?.er_code));     
                const extensions = score?.extensions; 
                const inquiry = extensions?.find(e => e?.ere_code === 'INQUIRY' && e?.ere_value === 'SUBMITTED') ? <>{asterisc}</> : <></>;
                
                return (<>{inquiry}{irmOrResult}</>)
            },
        }
    )
}

export function ColumnRankAllArround({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    remove = false,
    rotation = '',
    status = ''
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return status.includes('OFFICIAL') || row?.extendedResults?.filter(r => '|3_RIBBONS_2_BALLS|5_HOOPS|BALL|CLUBS|HOOP|RIBBON|'.includes(r?.er_code))?.find(r => r?.er_pos === rotation) ? <Rank data={row} /> : <></>;
            }
        }
    )
}

const Rank = ({data}) => {
    return data?.resultRank && data?.resultRankEqual ? `=${data?.resultRank}` : data?.resultRank ? data?.resultRank : '';
}
